// ====================================================================
// BUSINESS CONFIG — Woodstone Construction
// --------------------------------------------------------------------
// Single source of truth for branding & contact details.
// Update logo, phone, email, social links, and service area here.
// ====================================================================

export const BUSINESS = {
  name: "Woodstone Construction",
  tagline: "Melbourne-based decking & landscaping specialists",
  location: "Melbourne, VIC",
  serviceArea: "Melbourne and surrounding suburbs",

  phone: "0416164291",
  phoneDisplay: "0416 164 291",
  email: "woodstoneconstruct@outlook.com",

  // Logo — replace the URL below to change the logo across the site
  logoUrl:
    "https://customer-assets.emergentagent.com/job_woodstone-deck-quote/artifacts/5wunfg4v_logo.PNG",

  socials: {
    instagram:
      "https://www.instagram.com/woodstone.construction?igsh=MWJ5M2gwOXdza3NnYQ==",
    tiktok:
      "https://www.tiktok.com/@woodstone.construction?_r=1&_t=ZS-95ne7Vn7tMe",
  },
};

// JSON-LD LocalBusiness schema (SEO)
export const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: BUSINESS.name,
  description:
    "Composite and Merbau decking, pergolas, artificial turf, and landscaping services across Melbourne and surrounding suburbs.",
  image: BUSINESS.logoUrl,
  telephone: "+61416164291",
  email: BUSINESS.email,
  address: {
    "@type": "PostalAddress",
    addressLocality: "Melbourne",
    addressRegion: "VIC",
    addressCountry: "AU",
  },
  areaServed: "Melbourne and surrounding suburbs, VIC, Australia",
  sameAs: [BUSINESS.socials.instagram, BUSINESS.socials.tiktok],
  priceRange: "$$",
};
